module.exports = __webpack_public_path__ + "static/img/GettyImages-530055153.b2f09e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/GettyImages-530055153.jpg
// module id = M9Pv
// module chunks = 0